import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { useRelatorioAM } from "@/hooks/useRelatorioAM";
import { formatMessageError } from "@/utils/formatMessageError";
import { useQuery } from "@tanstack/react-query";
import { App, Col, Divider, Grid, List, Result, Row, Typography } from "antd";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { FiltroRelatoriosAM } from "../_components/FiltroRelatoriosAM";
import { ItemListPlanoAcaoRAM } from "./_components/ItemListPlanoAcaoRAM";

const PAGE_SIZE = 20;

export function PlanoAcaoRelatorioAM() {
  const screens = Grid.useBreakpoint();
  const { isOnline } = useNetworkStatus();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getRelatoriosAMApi } = useRelatorioAM();
  const { notification } = App.useApp();
  const page = searchParams.get("page") || "1";
  const currentPage = Number(page);

  const {
    data: listaTermosFiltro,
    isLoading: isLoadingFiltro,
    error: errorTermosFiltro,
  } = useQuery({
    queryKey: ["RAM_FILTRO_PLANO_ACAO", searchParams.toString()],
    enabled: isOnline && !!searchParams.get("estabelecimentoId"),
    queryFn: async () => {
      const response = await getRelatoriosAMApi({
        estabelecimentoId: Number(searchParams.get("estabelecimentoId")),
        page: currentPage,
        situacao: searchParams.get("situacao") || undefined,
      });
      return response;
    },
  });

  useEffect(() => {
    document.title =
      "Inspeção Mobile - Plano de Ação Relatórios de Auditoria e Monitoria";

    if (errorTermosFiltro) {
      const messageError = formatMessageError(errorTermosFiltro);
      notification.error({
        message:
          "Não foi possivel carregar a lista de relatórios de auditoria e monitoria.",
        description: messageError,
        key: "error-filtro",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorTermosFiltro]);

  if (!isOnline) {
    return <Result title="Sem conexão com a internet" status={"error"} />;
  }

  return (
    <>
      <Typography.Title
        level={screens.xs ? 4 : 3}
        style={{ textAlign: "center" }}
      >
        Plano de Ação Relatórios de Auditoria e Monitoria
      </Typography.Title>

      <Divider />

      <Row>
        <Col span={24} style={{ marginTop: 16 }}>
          <FiltroRelatoriosAM />
        </Col>
      </Row>

      <>
        <Divider>
          <Typography.Text strong>Resultados da busca</Typography.Text>
        </Divider>
        <List
          size="small"
          bordered
          dataSource={listaTermosFiltro?.content || []}
          renderItem={(item, index) => (
            <ItemListPlanoAcaoRAM key={index} item={item} />
          )}
          loading={isLoadingFiltro}
          pagination={{
            pageSize: PAGE_SIZE,
            position: "bottom",
            defaultCurrent: 1,
            current: Number(page),
            total: listaTermosFiltro?.totalElements || 0,
            showSizeChanger: false,
            onChange: (page) => {
              searchParams.set("page", String(page));
              setSearchParams(searchParams);
            },
            align: "end",
            size: "small",
          }}
        />
      </>
    </>
  );
}
